import {
  CONTINUOUS_EDUCATION_UNIT,
  CONTINUOUS_EDUCATION_UNIT_NAME,
} from 'components/organization-certification/step/education/education-step.constants';
import _capitalize from 'lodash-es/capitalize';
import _pick from 'lodash-es/pick';
import { HOUR } from '../../../global';
import { ProgressHours, UnitsData } from 'services/professional/certificates/certificates.interface';

export function getCapitalizedEducationUnitName(unitId: CONTINUOUS_EDUCATION_UNIT) {
  return _capitalize(
    unitId ? CONTINUOUS_EDUCATION_UNIT_NAME[unitId] : CONTINUOUS_EDUCATION_UNIT_NAME[CONTINUOUS_EDUCATION_UNIT.HOURS],
  );
}

export function geCorrectUnitsFromMilliseconds(units: number) {
  return units / HOUR; // Old BE versions sends hours in milliseconds
}

export function getUnitsData(educationContent: ProgressHours): UnitsData {
  const hoursData = educationContent.hours_data;
  const unitsData = educationContent.unitsData || educationContent.unitsDataWithoutAdvancedOptions;
  return (
    unitsData || {
      unitsIncompleted: geCorrectUnitsFromMilliseconds(hoursData.hours_incompleted),
      unitsCompleted: geCorrectUnitsFromMilliseconds(hoursData.hours_completed),
      unitsFull: geCorrectUnitsFromMilliseconds(hoursData.hours_full),
      unitsPendingVerification: geCorrectUnitsFromMilliseconds(hoursData.hours_pending_verification),
    }
  );
}

const FORM_DATA_ARRAY_ENDING = '[]';
const FORM_DATA_KEY_MAPPER = {
  'files[]': 'documents',
};

export function mapFormDataToJson(data: FormData) {
  const result = {};
  if (!data) {
    return result;
  }
  data.forEach((value: FormDataEntryValue, key: string) => {
    if (key.endsWith(FORM_DATA_ARRAY_ENDING)) {
      key = FORM_DATA_KEY_MAPPER[key] || key;
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(getValueFromFormDataValue(value));
    } else {
      key = FORM_DATA_KEY_MAPPER[key] || key;
      result[key] = getValueFromFormDataValue(value);
    }
  });
  return result;
}

function getValueFromFormDataValue(value: FormDataEntryValue) {
  if (value instanceof File) {
    return _pick(value, ['name', 'size']);
  }
  return value;
}
